import React, { useState, useContext } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileNav } from './MobileNav';
import { LanguageContext } from '../App';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  const {
    direction
  } = useContext(LanguageContext);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };
  return <div className="flex h-screen" data-id="element-641">
      {/* Sidebar for desktop */}
      <div className={`hidden md:flex md:flex-shrink-0 transition-all duration-300 ease-in-out ${sidebarCollapsed ? 'md:w-20' : 'md:w-64'}`} data-id="element-642">
        <div className="flex flex-col w-full" data-id="element-643">
          <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} data-id="element-644" />
        </div>
      </div>
      <div className="flex flex-col flex-1" data-id="element-645">
        <Header data-id="element-646" />
        <main className="flex-1 relative overflow-y-auto p-4 md:p-6 bg-gray-50 pb-16 md:pb-6" data-id="element-647">
          {children}
        </main>
        <div className="md:hidden" data-id="element-648">
          <MobileNav data-id="element-649" />
        </div>
      </div>
    </div>;
};